<template>
    <section>
        <form @submit.prevent="regist()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1672')}}
            <!-- 개인정보 입력 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1673')}}
            <!-- 개인정보를 확인 후 매장을 선택하세요. -->
        </div>
        <div class="mt38">
            
            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" id="emailEl">
                <i class="material-icons mdc-text-field__icon">
                    
                </i>
                <input type="email" class="mdc-text-field__input"
                    v-model="join.socialId"
                    maxlength="50"
                    readonly
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1627')}}
                        <!-- 이메일 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            

            <div class="mdc-text-field mdc-text-field--outlined w-full mt20" id="firstNameEl">
                <input type="text" class="mdc-text-field__input"
                    v-model="join.name.first"
                    readonly
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1610')}}
                        <!-- 성 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            

            <div class="mdc-text-field mdc-text-field--outlined w-full mt20 mb20" id="lastNameEl">
                <input type="text" class="mdc-text-field__input"
                    v-model="join.name.last"                            
                    readonly
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1611')}}
                        <!-- 이름 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
        </div>
        <div class="divider"></div>

        <div class="mt20">
            <div class="mdc-select mdc-select--outlined w-full" 
                id="storeEl"
            
            >
                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                <select class="mdc-select__native-control" name="store" v-model="store" v-validate="'required'">
                    <option  value="">
                        {{$t('1665')}}
                        <!-- 매장선택 -->
                    </option>
                    <option  v-for="store in storeList" :key="store.value" :value="store.value">
                        {{store.text}}
                    </option>
                </select>
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                        <!-- <label class="mdc-floating-label"></label> -->
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
        </div>


        <div class="mt50">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1675')}}
                <!-- 회원가입 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1676')}}
                <!-- 취소 -->
            </button>
        </div>

        <!-- {{join}} -->
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            emailTextField: null,
            firstNameTextField: null,
            lastNameTextField: null,

            submitState: false,
            storeList: null,
            store: ''
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    created() {
        if (
                !this.join.role || !this.join.responsibility || 
                !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || 
                !this.join.name.last || !this.join.socialId ||
                !this.join.socialLink.token || !this.join.socialLink.token

            ) {
            this.$router.go(-1)
        }
    },

    mounted() {
        this.setMaterialUi()
        this.fetchData()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE']),

        setMaterialUi() {
            this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
            this.emailTextField.useNativeValidation = false
            
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
            this.lastNameTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        fetchData() {
            joinApi.store().then((response) => {
                this.storeList = response.data.data
                const select = new MDCSelect(document.querySelector('#selectStore'))
            }).catch((err) => {

            })

            
        },

        // 회원가입 API 호출
        regist() {

            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_STORE(this.store)

                    let params = this.join
                    let responseData = null

                    joinApi.register(params).then((response) => {
                        console.log(response.data.data)
                        this.$router.push({name: 'JoinComplete'})

                    }).catch((err) => {
                        console.log(err.response)                        
                        responseData = err.response.data.meta
                        this.$error({content: responseData.errMsg}).then(() => {
                            this.$router.push('/login')
                        })
                        
                    })
                    
                } else{
                    // this.focusFirstInvalidElement()
                    this.$snackOpen({
                        contents: this.$t('948'), //매장을 선택하세요.
                        btnDisplay: ''
                    }).then(() => {})
                }
            })

            // this.INIT_JOIN_STORE()

            
        },
    },

    

}
</script>

<style scoped>

</style>
